module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_true_bg_mobile-f88ba4bd1e6faa9741823b3c03d03f26.svg";